import { loadable } from '../../../common/utils/lazyLoading';
const EContentLibraries = loadable(() => import('../EContentLibraries'));
export default [
    {
        id: 'libraries',
        title: 'Libraries',
        route: 'libraries',
        icon: 'books',
        component: EContentLibraries,
        permission: 'libraries',
    },
];
